import { LinkPlainInternal } from 'src/elements/links/Link.plain';
import { Color, setColor } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

interface LogoContainerLinkProps {
  logoColor?: Color;
  clickable?: boolean;
}

export const LogoContainerLink = styled(LinkPlainInternal).withConfig<LogoContainerLinkProps>({
  // Since this is extending an HTML element, we need to tell styled-components to forward the props
  shouldForwardProp: (prop, defaultValidatorFn) => !['logoColor'].includes(prop) && defaultValidatorFn(prop),
})`
  text-decoration: none;
  display: flex;

  ${(props) => (props.clickable ? '' : 'pointer-events: none;')}

  .animated-mighty-logo-container {
    width: 350px;

    path {
      fill: ${({ logoColor = 'greyText' }) => setColor(logoColor)};
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    .animated-mighty-logo-container {
      width: 210px;
    }
  }
`;
